import script from "./FormPriceComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormPriceComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormPriceComponent.vue?vue&type=style&index=0&id=00dced9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00dced9c"]])

export default __exports__